import { combineReducers } from "redux";
import { authentication } from "./authentication.reducer";
import { fuseListReducer } from "./fuselist.reducer";
import { testListReducer } from "./testlist.reducer";
import { testErrorListReducer } from "./test-error-list.reducer";
import { fuseAdoptionReducer } from "./fuse-adoption.reducer";
import { fuseDetailReducer } from "./fuse-detail.reducer";
import { testDetailReducer } from "./test-detail.reducer";
import { configurationOptionsReducer } from "./configuration-options.reducer";
import { supportFilesReducer } from "./fuse-support-files.reducer";
import { versionListReducer } from "./version.reducer";

import { targetGroupsListReducer } from "./target-groups-list.reducer";
import { targetGroupsSNReducer } from "./target-groups-sn.reducer";
import { targetGroupsRegionReducer } from "./target-groups-region.reducer";
import { targetGroupsPhysicalReducer } from "./target-groups-physical.reducer";
import { targetGroupsVirtualReducer } from "./target-groups-virtual.reducer";
import { targetGroupsVersionReducer } from "./target-groups-version.reducer";

import { globalReleaseReducer } from "./global-release.reducer";
import { limitedReleasesListReducer } from "./limited-releases.reducer";
import { limitedReleasesSNReducer } from "./limited-releases-sn.reducer";
import { limitedReleasesRegionReducer } from "./limited-releases-region.reducer";
import { limitedReleasesPhysicalReducer } from "./limited-releases-physical.reducer";
import { limitedReleasesVirtualReducer } from "./limited-releases-virtual.reducer";
import { limitedReleasesVersionReducer } from "./limited-releases-version.reducer";

import { hm5GlobalReleaseReducer } from "./hm5-global-release.reducer";
import { hm5LimitedReleasesListReducer } from "./hm5-limited-releases.reducer";
import { hm5LimitedReleasesDetailReducer } from "./hm5-limited-releases-detail.reducer";
import { hm5VersionListReducer } from "./hm5-version.reducer";

import { uaGlobalReleaseReducer } from "./ua-global-release.reducer";
import { uaLimitedReleasesListReducer } from "./ua-limited-releases.reducer";
import { uaLimitedReleasesDetailReducer } from "./ua-limited-releases-detail.reducer";
import { uaVersionListReducer } from "./ua-version.reducer";

import { vs2ngaGlobalReleaseReducer } from "./vs2nga-global-release.reducer";
import { vs2ngaLimitedReleasesListReducer } from "./vs2nga-limited-releases.reducer";
import { vs2ngaLimitedReleasesDetailReducer } from "./vs2nga-limited-releases-detail.reducer";
import { vs2ngaVersionListReducer } from "./vs2nga-version.reducer";

import { saGlobalReleaseReducer } from "./sa-global-release.reducer";
import { saLimitedReleasesListReducer } from "./sa-limited-releases.reducer";
import { saLimitedReleasesDetailReducer } from "./sa-limited-releases-detail.reducer";
import { saVersionListReducer } from "./sa-version.reducer";

import { vs2jen2GlobalReleaseReducer } from "./vs2jen2-global-release.reducer";
import { vs2jen2LimitedReleasesListReducer } from "./vs2jen2-limited-releases.reducer";
import { vs2jen2LimitedReleasesDetailReducer } from "./vs2jen2-limited-releases-detail.reducer";
import { vs2jen2VersionListReducer } from "./vs2jen2-version.reducer";

import { featureFlagsReducer } from "./feature-flags.reducer";

import { commonReducer } from "./common.reducer";
import { notificationReducer } from "./notification.reducer";
import { hmplusVersionListReducer } from "./hmplus-version.reducer";
import { hmplusGlobalReleaseReducer } from "./hmplus-global-release.reducer";
import { hmplusLimitedReleasesListReducer } from "./hmplus-limited-releases.reducer";
import { hmplusLimitedReleasesDetailReducer } from "./hmplus-limited-releases-detail.reducer";
import { fuseProvisioningReducer } from "./fuseprovisioning.reducer";
import { fuseProvisioningDetailReducer } from "./fuseprovisioning-detail.reducer";
import { fuseProvisioningEventsReducer } from "./fuseprovisioningEvents.reducer";
import { testImageReducer } from "./test-image.reducer";
import { inactiveFusesReducer } from "./inactive-fuses.reduces";

const rootReducer = combineReducers({
  authentication,
  fuseListReducer,
  testListReducer,
  testErrorListReducer,
  fuseAdoptionReducer,
  fuseDetailReducer,
  testDetailReducer,
  configurationOptionsReducer,
  supportFilesReducer,
  versionListReducer,
  globalReleaseReducer,
  limitedReleasesListReducer,
  limitedReleasesSNReducer,
  limitedReleasesRegionReducer,
  limitedReleasesPhysicalReducer,
  limitedReleasesVirtualReducer,
  limitedReleasesVersionReducer,
  hm5GlobalReleaseReducer,
  hm5LimitedReleasesListReducer,
  hm5LimitedReleasesDetailReducer,
  hm5VersionListReducer,
  uaGlobalReleaseReducer,
  uaLimitedReleasesListReducer,
  uaLimitedReleasesDetailReducer,
  uaVersionListReducer,
  saGlobalReleaseReducer,
  saLimitedReleasesListReducer,
  saLimitedReleasesDetailReducer,
  saVersionListReducer,
  vs2ngaGlobalReleaseReducer,
  vs2ngaLimitedReleasesListReducer,
  vs2ngaLimitedReleasesDetailReducer,
  vs2ngaVersionListReducer,
  vs2jen2GlobalReleaseReducer,
  vs2jen2LimitedReleasesListReducer,
  vs2jen2LimitedReleasesDetailReducer,
  vs2jen2VersionListReducer,
  commonReducer,
  notificationReducer,
  targetGroupsListReducer,
  targetGroupsSNReducer,
  targetGroupsRegionReducer,
  targetGroupsPhysicalReducer,
  targetGroupsVirtualReducer,
  targetGroupsVersionReducer,
  featureFlagsReducer,
  hmplusVersionListReducer,
  hmplusGlobalReleaseReducer,
  hmplusLimitedReleasesListReducer,
  hmplusLimitedReleasesDetailReducer,
  fuseProvisioningReducer,
  fuseProvisioningDetailReducer,
  fuseProvisioningEventsReducer,
  testImageReducer,
  inactiveFusesReducer,
});

export default rootReducer;
